module.exports = __webpack_public_path__ + "IconDelete32.png?ab5bea6a78de7602c5a727f8375da890";


//////////////////
// WEBPACK FOOTER
// ./Content/img/IconDelete32.png
// module id = 939
// module chunks = 1